<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 BÜRGER社とは
        v-layout.white_container.pa-3.justify-center(row wrap)
          v-layout.justify-center(row wrap)
            v-flex(xs12)
              img(src="/static/logo_buerger.svg" alt='ビュルガー社ロゴ' width=220 height=45 style='margin:0 auto')
            h2 ドイツトップブランド&nbsp;
              br.xs
              | ビュルガー社
            h3(style='font-size: 1.1rem') 1934年創立以来、
              br
              | 品質にこだわり続ける食品製造会社
            v-flex(xs12)
              p ドイツ・ビュルガー社は1934年に創立された食品製造会社です。
                br
                | ビュルガー社はその創立時より高品質の原料にこだわり、厳選された食材のみを使用してきました。1960年代に現社長のリヒャルト・ビルマイヤーが経営を引き継ぐと、ビュルガー社は加工食品、とりわけドイツ南西部の伝統的な家庭料理である"マウルタッシェン"に力を入れるようになりました。
                br
                | マウルタッシェンにおいて同社は市場シェアの80％以上を占めるまでに成長し、ヨーロッパでトップシェアを築いています。ビュルガー社の冷凍食品のラインアップはこの他にもさまざまなヨーロッパの郷土料理におよび、世界各国の料理まで含め、その数は現在約320種に及んでいます。
                br
                | 高い品質にこだわるビュルガー社の姿勢はこれからも受け継がれ、さらに磨かれていくでしょう。
            img.ma-4(src="/static/images/company_face.jpg" alt='リチャードビルマイヤー')
          v-layout(row wrap)
            a(href='http://www.buerger.de/' style='margin: 0 auto')
              v-btn(x-large dark flat center style='margin: 0 auto').primary.text-secondary ビュルガー社ホームページ
          v-layout.my-4.share.justify-center(row wrap)
            h3 ドイツシェアNo.1
            p.my-3 ビュルガー社はドイツマウルタッシェンの販売においてシェアNo.1の食品会社です。
            h4 シェアNo.1の理由
            ul
              li(v-for='(item, index) in share' :key='item.list') {{ item.list }}
          v-layout.section.motto(row wrap)
            h3 商品へのこだわり
            v-layout.motto_wrap(row wrap)
              v-flex.pa-3(xs12 sm4  v-for='(item, index) in motto' :style="'background-image:url('+ item.bg +')'" :key='item.index')
                h4(:style="'color:'+ item.color ") {{ item.title }}
                p {{ item.text }}
          v-layout.section.message(row wrap)
            v-layout(row wrap)
              v-flex(xs12 sm8)
                h3 日本のお客様へ
                h4 安心して美味しく食べられる製品のみをご提供したい
                p 食品製造に従事する者として、本日は皆様に私からお話したいことがあります。 食品の品質と安全性は、今日私たちが最も危惧することです。
                  | “食べる”という行為は人類の基本であり、太古より続く人間の欲求でもあります。そしてまた身体に良い行いをしたいというのも私たちの自然な欲求です。
                  | 確かな原料で生産された食品を美味しく食べたいと誰でも思うものです。
                  | 自身で納得し安心して美味しく食べられる製品のみをお客様にご提供させていただきます。
                  br
                  span.mr-2 ドイツビュルガー社 リチャードビルマイヤー
              v-flex.pa-2(sm4)
                v-img.mt-5(src="/static/images/company_massage.jpg" alt='ビュルガー社イメージ' contain)
            v-layout(row wrap v-for='(item, index) in message' :key='item.title').mb-3
              h3 {{ item.title }}
              v-flex(sm8)
                ul.mt-3
                  li.ml-2(v-for='item in item.list') {{ item.topic }}
              v-flex.pa-2(sm4)
                v-img.mt-2(:src='item.src' alt='ビュルガー社イメージ' contain)
            v-layout.section(row wrap)
              v-layout.profile(row wrap)
                v-flex(xs12 md6)
                  dl(v-for='(item, index) in profile')
                    dt {{ item.dt }}
                    dd {{ item.dd }}
                v-flex.my-3(xs12 md6)
                  v-layout(row wrap)
                    v-flex(md6 v-for="(item, index) in factory" :key='item.name')
                      v-img(:src='item.src' :alt='item.name' contain)
                      span.text-xs-center {{ item.name }}
            v-layout.section.original(row wrap)
              v-layout(row wrap)
              v-flex(xs6 md3 v-for='n in 4' :key="'img' + n" )
                v-img(:src="'/static/images/company_image0' + n + '.jpg'" alt="ビュルガー社イメージ")
              p.mt-3
                | The Buerger GmbH exists for more than 70 years. From the beginning, the company attached great importance to the pureness and freshness of the ingredients as well as their origin. This is why, Buerger only processes specially selected meats and vegetables.
                | Since the 1960s, when Richard Bihlmaier, a member of the second generation to run the family business, took over the management, Buerger concentrated its attention on the production of convenience foods and in particular, of "Maultaschen". This is a popular traditional local dish in South Germany. Besides this, the company offers a wide range of regional dishes, Italian delicate meals and international specialities. Frozen food items were introduced in 1983 and currently the full range of products extends to 320. The name of Buerger guarantees high quality. Britta and Martin Bihlmaier, the third generation in the family business, are committed to preserve this reputation.
    CommonFooter

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
  },
  data () {
    return {
      share: [
        {
          'list': '伝統的な料理の手作り感を損なわない製造方法'
        }, {
          'list': 'ISO9000/2000における安全性・信頼感の実績'
        }, {
          'list': '子供の頃から食べ続けられている絶対の安心感・高品質'
        }
      ],
      motto: [
        {
          'title': '原料',
          'text': '卵などドイツ近郊の契約農家を中心に、ほとんどがEU圏内からの調達になります。',
          'bg': '/static/images/company_motto01.jpg',
          'color': '#f19835'
        },
        {
          'title': '品質',
          'text': '数々の金賞を誇る生産工場でマイスター・スタッフが作りました。',
          'bg': '/static/images/company_motto02.jpg',
          'color': '#a5b925'
        },
        {
          'title': '管理',
          'text': '徹底されたライン・工場で、安心・安全・美味しさを追求しております。 ',
          'bg': '/static/images/company_motto03.jpg',
          'color': '#8a7967'
        }
      ],
      message: [
        {
          title: '安全性の証明',
          src: '/static/images/company_safety.jpg',
          list: [
            {
              'topic': '卵と精肉はすべてドイツ国内産です。ほとんどは生産工場周辺の農場より入荷します。'
            }, {
              'topic': '調味料は、フランス、ベルギーなどのドイツに隣接したヨーロッパの国々より入荷します。'
            }, {
              'topic': '継続的な残留農薬検査を実地しています。'
            }, {
              'topic': '精肉入荷時の知覚・生物・科学検査の実地をしています。'
            }, {
              'topic': '全ての製造過程における継続的なラボ検査を実地しています。'
            }, {
              'topic': '専門省庁と外部検査機関による工場抜打ち検査を容認しています。（ドイツ国内）'
            }, {
              'topic': '自社検査室の実態調査のために共同検査機関へ参加しています。'
            }, {
              'topic': 'HACCP（ハサップ、総合衛生管理製造過程）ISO(国際標準化機構) 9000/2000 インターナショナル フードスタンダート（Version4）'
            }, {
              'topic': 'トレーサビリティーを行っています。'
            }
          ]
        },
        {
          title: '生産者としての信念',
          src: '/static/images/company_belief.jpg',
          list: [
            {
              'topic': 'ドイツの伝統的な食品を伝承して行くということ。'
            }, {
              'topic': 'ハイテク機械で製造されているにもかかわらず、私の祖母にも喜んでもらえる昔ながらの味であること。'
            }, {
              'topic': '私の故郷・同胞・そして自然を守るための責任を痛感し製品製造にあたっているということ。'
            }, {
              'topic': '子を持つ父として、祖父として、塩分量には特に気を使い、小さい子供の口にも合うように調味しているということ。'
            }, {
              'topic': '私自身が自社製造品に対しもっとも厳しく要求の多い品質管理責任者となり、自信で納得し安心して美味しく食べられる製品のみをお客様にご提供させていただきます。'
            }
          ]
        }
      ],
      profile: [
        {
          dt: '代表取締役',
          dd: 'Richard Bihlmaier'
        }, {
          dt: '創立',
          dd: '1934年'
        }, {
          dt: '拠点',
          dd: 'Ditzingen 及び Crailsheim'
        }, {
          dt: '従業員数',
          dd: '600人'
        }, {
          dt: '生産量',
          dd: '1日あたり180トン'
        }, {
          dt: '商品数',
          dd: '320種類（内 冷凍食品120種類）'
        }
      ],
      factory: [
        {
          src: '/static/images/company_factory01.jpg',
          name: 'Ditzingen 工場'
        }, {
          src: '/static/images/company_factory02.jpg',
          name: 'Crailsheim 工場'
        }
      ]
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc
.section
  border-top 1px solid $color-primary
  padding 2rem 0
.share
  h3
    font-size 1.8rem
    font-family 'Kosugi', sans-serif
    font-weight 700
    color white
    text-shadow $color-primary 1px 0 3px
    width 100%
    background linear-gradient(rgba(0,0,0,1) 0%, rgba(0,0,0,1) 32%, rgba(234,20,18,1) 33%, rgba(234,20,18,1) 66%, rgba(255,181,0,1) 67%, rgba(255,181,0,1) 100%)
    margin 1rem 0
  li
    text-align center
    font-size .9rem
    margin .3rem 0
.motto
  .motto_wrap
    display flex
    justify-content space-between
    div
      background-repeat no-repeat
      background-position top right
      h4
        font-size 1.8rem
        text-align left
        margin-top .5rem
      p
        width 70%
        font-size .9rem
.message
  h3,h4
    text-align left
  h3
    font-size 1.3rem
    margin-top 1rem
  p
    font-size .9rem
  li
    font-size .9rem
    list-style disc
  span
    font-size .7rem
    text-align right
    display block
.profile
  font-size .8rem
  dl
    width 100%
  dt
    float left
    width 8rem

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Company/index.vue